export const appendDownloadLink = (url: string, filename?: string): void => {
  const link = document.createElement('a');
  link.href = url;

  if (filename) {
    link.download = filename;
  }

  const { body } = document;

  if (body) {
    body.appendChild(link);
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    body.removeChild(link);
  }
};
